import { render } from "./CoinSymbol.vue?vue&type=template&id=1a3ac187&scoped=true"
import script from "./CoinSymbol.vue?vue&type=script&lang=js"
export * from "./CoinSymbol.vue?vue&type=script&lang=js"

import "./CoinSymbol.vue?vue&type=style&index=0&id=1a3ac187&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3ac187"]])

export default __exports__